module.exports = __webpack_public_path__ + "static/img/cash-tree.237c419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cash-tree/cash-tree.png
// module id = GyE5
// module chunks = 216